// Password validation functions (centralized)

export const validatePassword = (value: string) => {
  if (!value) {
    return 'Password is required'
  }
  if (value.length < 8) {
    return 'Password must be at least 8 characters long'
  }
  return true
}

export const validateCurrentPassword = (value: string) => {
  if (!value) {
    return 'Current password is required'
  }
  return true
}

export const validateOptionalPassword = (value: string) => {
  if (!value) {
    return true // Optional, so empty is valid
  }
  if (value.length < 8) {
    return 'Password must be at least 8 characters long'
  }
  return true
}

export const createConfirmPasswordValidator = (getPasswordValue: () => string) => {
  return (value: string) => {
    if (!value) {
      return 'Please confirm your password'
    }
    if (value !== getPasswordValue()) {
      return 'Passwords do not match'
    }
    return true
  }
}

export const createOptionalConfirmPasswordValidator = (getPasswordValue: () => string) => {
  return (value: string) => {
    const passwordValue = getPasswordValue()
    // If password is empty, confirm password should also be empty
    if (!passwordValue) {
      return true // Both empty is valid
    }
    // If password is set, confirm password is required
    if (!value) {
      return 'Please confirm your password'
    }
    if (value !== passwordValue) {
      return 'Passwords do not match'
    }
    return true
  }
}
